import "./src/assets/styles/tailwind.css"
